import { Component, ViewChild, ElementRef, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { AppointmentService } from '../../services/appointment.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { merge, startWith, switchMap, catchError, map, of as observableOf, Subject, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import { Appointment } from '../appointment/appointment.component';

@Component({
  selector: 'app-opd',
  templateUrl: './opd.component.html',
  styleUrls: ['./opd.component.scss']
})
export class OpdComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  isMobileView = window.innerWidth <= 1024;
  scrollThumbWidth = 10;
  scrollThumbLeft = 0;
  initialLoad: boolean = true;
  isDataLoading: boolean = true;
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  dateQuery = new FormControl();
  formAction = "add";
  closeResult = '';
  isSubmitted: boolean = false;
  displayedColumns: string[] = ["pId","info","name","date","check_in_type","type","source","payment","status","action"];
  exportColumns:any = ["pId","OPD No","Name","Doctor","Date","Time","Check In","Visit","Source","Payment","Status"];
  exportArrayData:any = [];

  // Premium Dashboard Additions
  mobileInfoVisible : any;
  current_id_hover: any;
  topPosition: any;
  leftPosition: any;
  hoveredRow: any;
  showOpdFeature: boolean = false;
  isHospitalWise: boolean = false;
  departmentListDp: any = [];
  DoctorDpList: any = [];
  filtersObject: any = {};

  selected_tab = 'all';
  selectedStatus = 'check_in';
  statusFilter$ = new BehaviorSubject<string>('check_in');
  selectedType = '';
  overviewStats: any = {
    total: 0,
    in_progress: 0,
    waiting: 0,
    upcoming: 0,
    completed: 0,
    walk_in: 0,
    emergency: 0,
    online: 0,
    clinic: 0,
    cancelled: 0,
    no_shows: 0
  };
  overviewStatsSubject = new Subject<any>();

  app_count: any = {
    all: null,
    today: null,
    tomorrow: null,
    week: null,
    month: null
  };

  reminderFollowUp = false;
  reminderUpcoming = false;
  reminderSending = false;
  appointment = new Appointment();

  constructor(private router:Router, private toast:ToastrService, private api:AppointmentService,private modalService: NgbModal, private localStorage:LocalStorageService){
    this.isHospitalWise = this.localStorage.getHospitalWise() == "true";
    this.showOpdFeature = this.localStorage.checkFeatures('opd');
  }

  ngAfterViewInit() {
    // Subscribe to overview stats
    this.overviewStatsSubject.pipe(
      switchMap((param: any) => {
        return this.api.getAppointmentOverviewStats(param).pipe(
          catchError(() => observableOf({ stats: { total: 0, in_progress: 0, waiting: 0, upcoming: 0, completed: 0, walk_in: 0, emergency: 0, online: 0, clinic: 0, cancelled: 0, no_shows: 0 } }))
        );
      })
    ).subscribe((res: any) => {
      if (res && res.stats) {
        this.overviewStats = {
          total: res.stats.total || 0,
          in_progress: res.stats.in_progress || 0,
          waiting: res.stats.waiting || 0,
          upcoming: res.stats.upcoming || 0,
          completed: res.stats.completed || 0,
          walk_in: res.stats.walk_in || 0,
          emergency: res.stats.emergency || 0,
          online: res.stats.online || 0,
          clinic: res.stats.clinic || 0,
          cancelled: res.stats.cancelled || 0,
          no_shows: res.stats.no_shows || 0
        };
      }
    });

    this.loadData();
    this.updateScrollThumb();
    setTimeout(() => this.updateScrollThumb(), 100);
  }

  dateFilter(event:any)
  {
   this.dateQuery.setValue(event)
  }

  // load Initial table data based on source type
  loadData() {
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(
        this.dateQuery.valueChanges,
        this.searchQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page,
        this.statusFilter$
      ).pipe(
        startWith({}),
        switchMap(() => {
          this.isDataLoading = true;
          let param: any = {
            where: { hospital_id: this.localStorage.getHospitalId(), center_id: this.localStorage.getCenterId() },
            filter: this.searchQuery.value,
            custom_filter: this.filtersObject,
            page: (this.paginator.pageIndex * this.paginator.pageSize),
            limit: this.paginator.pageSize,
            order: [{ col: 'app_id', dir: "desc" }, { col: 'appointment_date', dir: "desc" }, { col: 'appointment_time', dir: "desc" }],
          };
          if (this.dateQuery.value) { param = { ...param, ...this.dateQuery.value }; }
          if (this.localStorage.checkFullAccessForTableList(this.localStorage.getRole())) {
            param = param;
          } else {
            param = { ...param, user_id: this.localStorage.getUserId() };
          }
          if (this.selectedStatus) {
            param = { ...param, status: this.selectedStatus };
          }
          if (this.selectedType) {
            param = { ...param, appointment_type: this.selectedType };
          }

          this.fetchOverviewStats(param);

          return this.api.getAllAppointmentWithCount(param).pipe(
            catchError(() => observableOf(null))
          );
        }),
        map((response: any) => {
          this.initialLoad = false;
          if (response === null) {
            return [];
          }
          if (this.selected_tab === 'all') {
            this.app_count = { all: response.count, today: null, tomorrow: null, week: null, month: null };
          } else if (this.selected_tab === 'today') {
            this.app_count = { all: null, today: response.count, tomorrow: null, week: null, month: null };
          } else if (this.selected_tab === 'tomorrow') {
            this.app_count = { all: null, today: null, tomorrow: response.count, week: null, month: null };
          } else if (this.selected_tab === 'week') {
            this.app_count = { all: null, today: null, tomorrow: null, week: response.count, month: null };
          } else if (this.selected_tab === 'month') {
            this.app_count = { all: null, today: null, tomorrow: null, week: null, month: response.count };
          }
          this.totalRows = response.count;
          return response;
        })
      ).subscribe({
        next: (data: any) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          if (data && data.rows) {
            this.exportArrayData = data.rows;
            this.dataSource = new MatTableDataSource<any>(data.rows);
          } else {
            this.exportArrayData = [];
            this.dataSource = new MatTableDataSource<any>([]);
          }
        },
        error: (e) => {
          this.initialLoad = false;
          this.isDataLoading = false;
          console.error(e);
        },
        complete: () => {
          this.initialLoad = false;
        }
      });
    } catch (e) {
      this.initialLoad = false;
      console.error(e);
    }
  }

  searchFilter(query:any){

   // alert(query)
    this.searchQuery.setValue(query);
  }
  open(content:any){
  
    this.modalService.open(content, { size:'lg', scrollable: false}).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			},
		);

  }
   getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}
  gotoPatient(item:any)
  {
    localStorage.setItem('pId', item.pId);
    const serialized = this.router.serializeUrl(
      this.router.createUrlTree(['main/out-patient/record', item.id, item.appointment.app_id])
    );
    window.open(window.location.pathname + '#' + serialized, '_blank');
  }
  
  sourceImage = [{
    name:"webapp",
    img:"create.png"
  },
  {
    name:"tina",
    img:"tina-social.png"
  },
  {
    name:"whatsapp",
    img:"logos_whatsapp-icon.png"
  },
  {
    name:"twitter",
    img:"logos_twitter.png"
  },
  {
    name:"facebook",
    img:"logos_facebook.png"
  },
  {
    name:"instagram",
    img:"instagram-icon.png"
  },
  {
    name:"youtube",
    img:"logos_youtube-icon.png"
  },
  {
    name:"messenger",
    img:"logos_messenger.png"
  }]
  getsourceImage(source:any)
  {
    let img:any ="create.png";
  
    let tempImage:any =  this.sourceImage.find((item:any) => {
     return item.name === source;
    })

    if(tempImage)
    {
       img = tempImage.img
    }else
    {
      img = "create.png"
    }
    return img;

  }
  export(header:any)
  {
    //console.log(header)
    let excelRowData:any = [];
    this.exportArrayData.forEach((element:any) => {
     let status = "";
     if( element.appointment.status=="booked")
     {
       status = element.appointment.status.replaceAll('booked','Booked')
     }
     else if( element.appointment.status=="check_in" )
     {
       status = element.appointment.status.replaceAll('check_in','Checked In')
     }
     else if( element.appointment.status=="rescheduled" )
     {
       status = element.appointment.status.replaceAll('rescheduled','Rescheduled')
     }
     else if( element.appointment.status=="cancelled")
     {
       status = element.appointment.status.replaceAll('cancelled','Cancelled')
     }
     else if( element.appointment.status=="no_show")
     {
       status = element.appointment.status.replaceAll('no_show','No Show')
     }
     
     excelRowData.push({0:element.pId,1:element.appointment.opd_number,2:element.fname+" "+element.lname,3:element.appointment.user.fname+" "+element.appointment.user.lname,4:element.appointment.appointment_date,5:element.appointment.appointment_time,6:element.appointment.check_in_type,7:element.appointment.appointment_type,8:element.appointment.appointment_source,9:element.appointment.details,10:status})
   });

    let excelData = [];
    let excelHeader = [];
      for (let i = 0; i < excelRowData.length; i++) {
        let element = excelRowData[i];
        let obj:any = {}
        for (let index = 0; index < header.length; index++) {
          let key = header[index]['key'];
          obj[key] = element[key]
        }
        excelData.push(obj)
      }
      for (let index = 0; index < header.length; index++) {
        let value = header[index]['value'];
        excelHeader.push(value)
      }
    //console.log(excelData)
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, [excelHeader]);
    XLSX.utils.sheet_add_json(ws,excelData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth()+1;
    let year = date.getFullYear();

  XLSX.writeFile(wb, "Out_Patient_"+day+"_"+month+"_"+year+"_"+date.getTime()+".csv");
  }

@HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = window.innerWidth <= 1024;
  }

handleScrollLeft() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: -150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

handleScrollRight() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: 150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

updateScrollThumb() {
  if (!this.scrollContainer) return;

  const container = this.scrollContainer.nativeElement;
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;
  const scrollLeft = container.scrollLeft;

  if (scrollWidth > clientWidth) {
    this.scrollThumbWidth = Math.max(10, Math.min(100, (clientWidth / scrollWidth) * 100));
    const maxScrollLeft = scrollWidth - clientWidth;
    const scrollPercentage = (scrollLeft / maxScrollLeft) * 100;
    this.scrollThumbLeft = (scrollPercentage * (100 - this.scrollThumbWidth)) / 100;
    this.scrollThumbLeft = Math.max(0, Math.min(100 - this.scrollThumbWidth, this.scrollThumbLeft));
  } else {
    this.scrollThumbWidth = 100;
    this.scrollThumbLeft = 0;
  }
}

  toggleStatusFilter(status: string) {
    if (this.selectedStatus === status) {
      this.selectedStatus = '';
    } else {
      this.selectedStatus = status;
    }
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.statusFilter$.next(this.selectedStatus);
  }

  toggleTypeFilter(type: string) {
    if (this.selectedType === type) {
      this.selectedType = '';
    } else {
      this.selectedType = type;
    }
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.statusFilter$.next(this.selectedStatus);
  }

  loadAppointmentByTab(type: string) {
    this.selectedStatus = 'check_in';
    this.statusFilter$.next('check_in');
    if (type === "all") {
      this.dateFilter("");
      this.selected_tab = 'all';
    } else if (type === "today") {
      this.dateQuery.setValue({ startDate: new Date(), endDate: new Date() });
      this.selected_tab = 'today';
    } else if (type === "tomorrow") {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      this.dateQuery.setValue({ startDate: tomorrow, endDate: tomorrow });
      this.selected_tab = 'tomorrow';
    } else if (type === "week") {
      const today = new Date();
      const dayOfWeek = today.getDay();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - dayOfWeek);
      const endOfWeek = new Date(today);
      endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));
      this.dateQuery.setValue({ startDate: startOfWeek, endDate: endOfWeek });
      this.selected_tab = 'week';
    } else if (type === "month") {
      const today = new Date();
      const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.dateQuery.setValue({ startDate: currentMonthStart, endDate: currentMonthEnd });
      this.selected_tab = 'month';
    }
  }

  fetchOverviewStats(param: any) {
    const countParam = {
      ...param
    };
    
    // Explicitly pass status: "check_in" for OPD stats as requested
    countParam.status = 'check_in';
    
    if (countParam.appointment_type) {
      delete countParam.appointment_type;
    }
    this.overviewStatsSubject.next(countParam);
  }

  getTabOverviewTitle(): string {
    switch (this.selected_tab) {
      case 'today':
        return "Today's Overview";
      case 'tomorrow':
        return "Tomorrow's Overview";
      case 'week':
        return "Week's Overview";
      case 'month':
        return "Month's Overview";
      default:
        return "Overall Overview";
    }
  }

  formatTo12Hour(time: string): string {
    if (this.localStorage.isTwelveHourFormat()) {
      return moment(time, 'HH:mm').format('hh:mm A');
    } else {
      return time;
    }
  }

  openWalkInModal() {
    this.appointment = new Appointment();
    this.appointment.appointment_type = 'walk_in';
    this.appointment.appointment_source = 'walk_in';
    this.formAction = 'add';
    const modalRef = this.modalService.open(this.contentTemplate, { size: 'lg', scrollable: false });
  }

  // Get the TemplateRef for the content from NgbModal template
  @ViewChild('content') contentTemplate!: any;

  openScheduleModal(content: any) {
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true, windowClass: 'modal-schedule-popup' });
  }

  openReportsModal(content: any) {
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true, windowClass: 'modal-reports-popup' });
  }

  openRemindersModal(content: any) {
    this.reminderFollowUp = false;
    this.reminderUpcoming = false;
    this.reminderSending = false;
    this.modalService.open(content, { size: 'md', scrollable: false, centered: true, windowClass: 'modal-reminders-popup' });
  }

  sendReminders(modal: any) {
    if (!this.reminderFollowUp && !this.reminderUpcoming) return;
    this.reminderSending = true;
    const types: string[] = [];
    if (this.reminderFollowUp) types.push('follow_up');
    if (this.reminderUpcoming) types.push('upcoming');
    setTimeout(() => {
      this.reminderSending = false;
      this.toast.success(`Reminders sent to ${types.join(' & ')} patients`, 'Success');
      modal.dismiss();
    }, 1500);
  }

  getFollowUpPatients(): any[] {
    if (!this.dataSource?.data) return [];
    return this.dataSource.data.filter(item => {
      const type = (item.appointment?.check_in_type || '').toLowerCase();
      const appType = (item.appointment?.appointment_type || '').toLowerCase();
      return type.includes('follow-up') || type.includes('follow_up') || 
             appType.includes('follow_up') || appType.includes('follow-up');
    });
  }

  getUpcomingPatients(): any[] {
    if (!this.dataSource?.data) return [];
    const todayStr = moment().format('YYYY-MM-DD');
    const tomorrowStr = moment().add(1, 'day').format('YYYY-MM-DD');
    return this.dataSource.data.filter(item => {
      const d = item.appointment?.appointment_date ? moment(item.appointment.appointment_date).format('YYYY-MM-DD') : '';
      return d === todayStr || d === tomorrowStr;
    });
  }

  getSelectedPatients(): any[] {
    const list: any[] = [];
    const seenIds = new Set<any>();

    const addToList = (patients: any[]) => {
      patients.forEach(p => {
        const appId = p.appointment?.app_id;
        if (appId && !seenIds.has(appId)) {
          seenIds.add(appId);
          list.push(p);
        }
      });
    };

    if (this.reminderFollowUp) {
      addToList(this.getFollowUpPatients());
    }
    if (this.reminderUpcoming) {
      addToList(this.getUpcomingPatients());
    }
    return list;
  }

  getSelectedPatientsCount(): number {
    return this.getSelectedPatients().length;
  }

  showFilterData(event: any) {
    if (event) {
      this.loadDepartments();
      this.loadDoctorsByDepartments();
    }
  }

  loadDepartments() {
    let param = {
      where: {
        hospital_id: this.localStorage.getHospitalId(),
        isPublic: true,
      }
    };
    this.api.getDepartments(param).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.departmentListDp = response;
        }
      },
      error: (e) => {}
    });
  }

  loadDoctorsByDepartments() {
    let param = {
      hospital_id: this.localStorage.getHospitalId(),
      center_id: this.localStorage.getCenterId(),
    };
    if (this.localStorage.getIgnoreCenterCheck() == "true") {
      delete param.center_id;
    }
    this.api.getUserByDepartmentSchedule(param).subscribe({
      next: (response) => {
        this.DoctorDpList = response;
      },
      error: (e) => {}
    });
  }

  showInfo(row: any, event: any) {
    this.hoveredRow = row;
    this.topPosition = event.clientY;
    this.leftPosition = event.clientX;
    this.current_id_hover = row.appointment.app_id;
  }

  onMouseMove(row: any, event: MouseEvent): void {
    this.current_id_hover = row.appointment.app_id;
  }

  hideInfo() {
    this.current_id_hover = "";
    this.mobileInfoVisible = null;
  }

  toggleMobileInfo(element: any) {
    this.mobileInfoVisible = this.mobileInfoVisible === element.appointment.app_id ? null : element.appointment.app_id;
    if (window.innerWidth > 768) {
      this.current_id_hover = "";
    }
  }

  handleShowInfo(element: any, event: any) {
    this.showInfo(element, event);
    this.toggleMobileInfo(element);
  }

  customSearchFilter(event: any) {
    this.filtersObject = event;
    this.loadData();
  }

  formatAppointmentType(type: string): string {
    if (!type) return '';
    const formatted = type.replace('_', ' ');
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }
}



